// import { createAsyncThunk } from "@reduxjs/toolkit";
// import { axiosGateway as api } from "../../api/axios";
// import ENDPOINTS from "../../api/endpoints";

// // helper: normalize to trimmed string or undefined
// const toStr = (v) => (v == null ? undefined : String(v).trim());

// /**
//  * Fetch likes aggregation for a post: { count, users[] }
//  * GET /likes?postId=...
//  */
// export const fetchLikesByPost = createAsyncThunk(
//   "likes/fetchLikesByPost",
//   async (postId, { rejectWithValue }) => {
//     try {
//       const pid = toStr(postId);
//       if (!pid) throw new Error("postId is required");

//       const { data } = await api.get(`/likes`, {
//         params: { postId: pid }
//       });

//       return {
//         postId: pid,
//         count: data?.count ?? 0,
//         users: data?.users ?? []
//       };
//     } catch (err) {
//       console.error('[Likes] Fetch error:', err?.response?.data || err);
//       return rejectWithValue(err?.response?.data || err?.data || err);
//     }
//   }
// );

// /**
//  * Get like status: /likes/status?postId=...&userId=...
//  * Returns { liked: boolean, count: number }
//  */
// export const fetchLikeStatus = createAsyncThunk(
//   "likes/fetchLikeStatus",
//   async ({ postId, userId }, { rejectWithValue }) => {
//     try {
//       const pid = toStr(postId);
//       const uid = toStr(userId);
//       if (!pid || !uid) throw new Error("postId and userId are required");

//       const { data } = await api.get(`/likes/status`, {
//         params: {
//           postId: pid,
//           userId: uid
//         }
//       });

//       return {
//         postId: pid,
//         status: {
//           liked: !!data?.liked,
//           count: data?.count ?? 0
//         }
//       };
//     } catch (err) {
//       console.error('[Likes] Status error:', err?.response?.data || err);
//       return rejectWithValue(err?.response?.data || err?.data || err);
//     }
//   }
// );

// /**
//  * Toggle like: POST /likes
//  * Returns new status for the post
//  */
// export const toggleLike = createAsyncThunk(
//   "likes/toggleLike",
//   async (dto, { rejectWithValue }) => {
//     try {
//       // Build clean body (postOwnerId is optional)
//       const body = {
//         postId: toStr(dto.postId),
//         userId: toStr(dto.userId),
//         ...(dto?.postOwnerId ? { postOwnerId: toStr(dto.postOwnerId) } : {}),
//       };

//       if (!body.postId || !body.userId) throw new Error('postId and userId are required');

//       console.debug('[Likes] Posting toggle body:', body);

//       // Toggle like/unlike
//       const toggleResponse = await api.post(`/likes`, body);

//       // Re-fetch updated status
//       const { data } = await api.get(`/likes/status`, {
//         params: {
//           postId: body.postId,
//           userId: body.userId
//         }
//       });

//       return {
//         postId: body.postId,
//         status: {
//           liked: !!data?.liked,
//           count: data?.count ?? 0
//         }
//       };
//     } catch (err) {
//       console.error('[Likes] Toggle error:', err?.response?.data || err);
//       return rejectWithValue(err?.response?.data || err?.data || err);
//     }
//   }
// );


// import { createAsyncThunk } from "@reduxjs/toolkit";
// import { axiosGateway as api } from "../../api/axios";
// import ENDPOINTS from "../../api/endpoints";

// const toStr = (v) => (v == null ? undefined : String(v).trim());

// const toInt = (v) => {
//   if (v == null) return undefined;
//   const n = Number(v);
//   return Number.isFinite(n) ? n : undefined;
// };


// /**
//  * Fetch likes aggregation for a post: { count, users[] }
//  * GET /likes?postId=...
//  */
// export const fetchLikesByPost = createAsyncThunk(
//   "likes/fetchLikesByPost",
//   async (postId, { rejectWithValue }) => {
//     try {
//       const pid = toStr(postId);
//       if (!pid) throw new Error("postId is required");

//       const { data } = await api.get(`/likes`, {
//         params: { postId: pid },
//       });


//       return {
//         postId: pid,
//         count: data?.count ?? 0,
//         users: data?.users ?? [],
//       };
//     } catch (err) {
//       console.error("[Likes] Fetch error:", err?.response?.data || err);
//       return rejectWithValue(err?.response?.data || err?.data || err);
//     }
//   }
// );

// /**
//  * Get like status: /likes/status?postId=...&userId=...
//  * Returns { liked: boolean, count: number }
//  */
// export const fetchLikeStatus = createAsyncThunk(
//   "likes/fetchLikeStatus",
//   async ({ postId, userId }, { rejectWithValue }) => {
//     try {
//       const pid = toStr(postId);
//       const uid = toInt(userId); // ✅ FIX: must be integer

//       if (!pid || uid == null) {
//         throw new Error("postId and numeric userId are required");
//       }

//       const { data } = await api.get(`/likes/status`, {
//         params: {
//           postId: pid,
//           userId: uid, // ✅ number
//         },
//       });


//       return {
//         postId: pid,
//         status: {
//           liked: !!data?.liked,
//           count: data?.count ?? 0,
//         },
//       };
//     } catch (err) {
//       console.error("[Likes] Status error:", err?.response?.data || err);
//       return rejectWithValue(err?.response?.data || err?.data || err);
//     }
//   }
// );

// /**
//  * Toggle like: POST /likes
//  * Returns new status for the post
//  */
// export const toggleLike = createAsyncThunk(
//   "likes/toggleLike",
//   async (dto, { rejectWithValue }) => {
//     try {
//       const body = {
//         postId: toStr(dto?.postId),
//         userId: toInt(dto?.userId), // ✅ FIX: must be integer
//         ...(dto?.postOwnerId != null
//           ? { postOwnerId: toInt(dto?.postOwnerId) } // ✅ FIX: must be integer
//           : {}),
//       };

//       if (!body.postId || body.userId == null) {
//         throw new Error("postId and numeric userId are required");
//       }

//       // postOwnerId is optional, but if provided must be numeric
//       if (dto?.postOwnerId != null && body.postOwnerId == null) {
//         throw new Error("postOwnerId must be numeric when provided");
//       }

//       console.debug("[Likes] Posting toggle body:", body);

//       // Toggle like/unlike
//       const toggleResponse = await api.post(`/likes`, body);

//       // Re-fetch updated status
//       const { data } = await api.get(`/likes/status`, {
//         params: {
//           postId: body.postId,
//           userId: body.userId, // ✅ number
//         },
//       });


//       return {
//         postId: body.postId,
//         status: {
//           liked: !!data?.liked,
//           count: data?.count ?? 0,
//         },
//       };
//     } catch (err) {
//       console.error("[Likes] Toggle error:", err?.response?.data || err);
//       return rejectWithValue(err?.response?.data || err?.data || err);
//     }
//   }
// );


// =======================================
// frontend/src/Redux/thunks/likesThunks.js
// Fusion des 2 versions :
// - endpoints /likes et /likes/status (comme ton code)
// - body clean (postOwnerId optionnel)
// - support IDs en string OU number (cast number quand possible)
// - normalizeError style "robuste" (comme commentsThunks)
// - support réponses multiples (direct / {data:..})
// =======================================
import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosLikes as api } from "../../../api/axios";
import ENDPOINTS from "../../../api/endpoints";

/* ---------- Helpers ---------- */
const normalizeError = (err, fallbackMessage) => {
  const data =
    err?.data ||
    err?.response?.data ||
    { message: err?.message || fallbackMessage };

  return {
    message: data?.message || fallbackMessage,
    status: err?.status || err?.response?.status,
    details: data,
  };
};

// helper: normalize to trimmed string or undefined
const toStr = (v) => (v == null ? undefined : String(v).trim());

const resolveStoredActor = () => {
  if (typeof window === "undefined") return undefined;
  const tokens = [
    localStorage.getItem("doctorAccessToken"),
    localStorage.getItem("doctor_token"),
    localStorage.getItem("accessToken"),
    sessionStorage.getItem("accessToken"),
  ].filter(Boolean);

  for (const token of tokens) {
    try {
      const payload = JSON.parse(atob(String(token).split(".")[1] || ""));
      const id = payload?.sub || payload?.id || payload?.userId;
      if (id != null) return String(id).trim() || undefined;
    } catch {
      // Ignore non-JWT storage values.
    }
  }

  return toStr(
    localStorage.getItem("userId") ||
      sessionStorage.getItem("userId")
  );
};

// ✅ accept UUID string or numeric string/number. Returns lowercase UUID or number.
const isUUID = (v) =>
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/.test(
    String(v).toLowerCase()
  );

const toIntOrUndef = (v) => {
  if (v === null || v === undefined) return undefined;
  const s = String(v).trim();
  if (!s) return undefined;
  if (isUUID(s)) return s.toLowerCase();
  const n = Number(s);
  return Number.isFinite(n) ? n : undefined;
};

// ✅ extract from multiple response shapes
const unwrap = (data) => data?.data ?? data;

/**
 * Fetch likes aggregation for a post: { count, users[] }
 * GET /likes?postId=...
 */
export const fetchLikesByPost = createAsyncThunk(
  "likes/fetchLikesByPost",
  async (postId, { rejectWithValue, signal }) => {
    try {
      const pid = toStr(postId);
      if (!pid) throw new Error("postId is required");

      // ✅ keep your route (gateway): GET /likes?postId=...
      const { data } = await api.get(`/`, {
        params: { postId: pid },
        signal,
      });

      const payload = unwrap(data);

      return {
        postId: pid,
        count: payload?.count ?? 0,
        users: payload?.users ?? [],
      };
    } catch (err) {
      console.error("[Likes] Fetch error:", err?.response?.data || err);
      return rejectWithValue(normalizeError(err, "Failed to fetch likes"));
    }
  }
);

/**
 * Get like status: /likes/status?postId=...&userId=...
 * Returns { liked: boolean, count: number }
 */
export const fetchLikeStatus = createAsyncThunk(
  "likes/fetchLikeStatus",
  async ({ postId, userId }, { rejectWithValue, signal }) => {
    try {
      const pid = toStr(postId);

      // ✅ fusion: si ton backend attend number -> on envoie number quand possible,
      // sinon on retombe sur string (compat)
      const uidInt = toIntOrUndef(userId);
      const uidStr = toStr(userId);

      if (!pid || (!uidStr && uidInt == null)) {
        throw new Error("postId and userId are required");
      }

      const { data } = await api.get(`/status`, {
        params: {
          postId: pid,
          userId: uidInt ?? uidStr, // ✅ number si possible sinon string
        },
        signal,
      });

      const payload = unwrap(data);

      return {
        postId: pid,
        status: {
          liked: !!payload?.liked,
          count: payload?.count ?? 0,
        },
      };
    } catch (err) {
      console.error("[Likes] Status error:", err?.response?.data || err);
      return rejectWithValue(normalizeError(err, "Failed to fetch like status"));
    }
  }
);

/**
 * Toggle like: POST /likes
 * Returns new status for the post (via re-fetch /likes/status)
 */
export const toggleLike = createAsyncThunk(
  "likes/toggleLike",
  async (dto, { rejectWithValue, getState }) => {
    try {
      const postId = toStr(dto?.postId);

      const authUser =
        getState()?.auth?.user ||
        getState()?.user?.currentUser ||
        getState()?.doctor?.user ||
        getState()?.users?.currentUser;
      const userIdStr = toStr(
        dto?.userId ||
          authUser?.id ||
          authUser?._id ||
          authUser?.userId ||
          resolveStoredActor()
      );

      const ownerIdInt = toIntOrUndef(dto?.postOwnerId);
      const ownerIdStr = toStr(dto?.postOwnerId);

      if (!postId) throw new Error("postId is required");
      if (!userIdStr) throw new Error("userId is required");

      // ✅ body clean: postOwnerId optionnel
      const body = {
        postId,
        userId: userIdStr,
        ...(dto?.postOwnerId != null
          ? { postOwnerId: ownerIdInt ?? ownerIdStr }
          : {}),
      };

      // ✅ si postOwnerId fourni mais illisible
      if (dto?.postOwnerId != null && body.postOwnerId == null) {
        throw new Error("postOwnerId is invalid");
      }

      console.debug("[Likes] Posting toggle body:", body);

      await api.post("/", body);

      // The toggle endpoint returns only a message. The pending reducer has
      // already applied the next state locally, so avoid a second request.
      const currentStatus = getState()?.likes?.status?.[postId] || {
        liked: false,
        count: 0,
      };

      return {
        postId,
        status: {
          liked: !!currentStatus.liked,
          count: currentStatus.count ?? 0,
        },
      };
    } catch (err) {
      console.error("[Likes] Toggle error:", err?.response?.data || err);
      return rejectWithValue(normalizeError(err, "Failed to toggle like"));
    }
  }
);
